import { render, staticRenderFns } from "./ExtractionDossierJournal.vue?vue&type=template&id=099af90e&scoped=true"
import script from "./ExtractionDossierJournal.vue?vue&type=script&lang=js"
export * from "./ExtractionDossierJournal.vue?vue&type=script&lang=js"
import style0 from "./ExtractionDossierJournal.vue?vue&type=style&index=0&id=099af90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099af90e",
  null
  
)

export default component.exports